import React, { useState, useRef, useEffect } from 'react';
import '../Academy/NewAcademy.css';
import { Link, Navigate } from 'react-router-dom';
import Select from "react-select";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { useUser } from '../context/UserContext';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from "use-places-autocomplete";

const NewAcademy = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem('auth-token');
  const { selectedCenter } = useUser();
  const [contactNumber, setContactNumber] = useState('');
  const academyData = location.state ? location.state.academy.id : null;
  const [isParentAcademy, setIsParentAcademy] = useState(true);
  const [selectedParentAcademy, setSelectedParentAcademy] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [about, setAbout] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [sport, setSport] = useState('');
  const [facility, setFacility] = useState('');
  const [locality, setLocality] = useState('');
  const [coverPicture, setCoverPicture] = useState(null);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [maxActiveMembership, setMaxActiveMembership] = useState('');
  const [sportOptions, setSportOptions] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [academyOptions, setAcademyOptions] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [fetchedAcademy, setFetchedAcademy] = useState(null);
  const [coverPicUrl, setCoverPicUrl] = useState('');
  const [coverPreview, setCoverPreview] = useState('');
  const autocompleteWrapperRef = useRef(null);
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: { country: "IN" },
    },
    debounce: 300
  });

  const suggestionOptions = data.map(({ place_id, description }) => ({
    value: description,
    label: description,
    placeId: place_id
  }));

  const handleSelect = async (address, placeId) => {
    setValue(address, false);
    clearSuggestions();
    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    let addressName = "";
    if (placeId && window.google?.maps?.places) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      await new Promise((resolve) => {
        service.getDetails(
          { placeId, fields: ["name"] },
          (placeResult, status) => {
            if (
              status ===
              window.google.maps.places.PlacesServiceStatus.OK
            ) {
              addressName = placeResult.name;
            }
            resolve(null);
          }
        );
      });
    }
    setForm((prev) => ({
      ...prev,
      latitude: lat,
      longitude: lng,
      formatted_address: results[0].formatted_address,
      localityNameString: address,
      localityJson: JSON.stringify(results[0]),
      addressName,
    }));
    setLocality(address);
  };

  useEffect(() => {
    let el;

    window.customElements.whenDefined('place-autocomplete').then(() => {
      el = document.createElement('place-autocomplete');
      el.placeholder = 'Search Locality';
      el.bounds = {
        north: 35.513327,
        south: 6.4626999,
        west: 68.1097,
        east: 97.395358
      };
      el.componentRestrictions = { country: 'IN' };
      el.types = ['establishment', 'geocode'];

      autocompleteWrapperRef.current.appendChild(el);

      el.addEventListener('gmp-select', async (e) => {
        const prediction = e.detail.placePrediction;
        const place = prediction.toPlace();
        await place.fetchFields({
          fields: [
            'displayName',
            'formattedAddress',
            'geometry',
            'placeId',
            'formattedPhoneNumber',
            'website',
            'openingHours'
          ]
        });

        setForm(prev => ({
          ...prev,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          formatted_address: place.formattedAddress,
          place_id: place.placeId,
          formatted_phone_number: place.formattedPhoneNumber,
          website: place.website,
          opening_hours: place.openingHours,
          localityJson: JSON.stringify(place),
          localityNameString: place.displayName

        }));
        setLocality(place.displayName);
      });
    });

    return () => {
      if (el) el.remove();
    };
  }, []);

  const handleParentAcademyChange = (e) => {
    setIsParentAcademy(e.target.checked);
    if (e.target.checked) {
      setSelectedParentAcademy(null);
    }
  };

  const [form, setForm] = useState({
    id: null || selectedCenter,
    name: "",
    email: "",
    password: "",
    about: "",
    mobileNumber: "",
    address: "",
    isNotificationEnabled: true,
    isAvailableForMachaxiTrial: false,
    latitude: "",
    longitude: "",
    localityId: 0,
    localityJson: "",
    localityNameString: "",
    addressName: "",
    contactNumber: "",
    maxActivePlayingMembership: '',
    offering: " ",
    facilityId: [],
    sportIds: [],
    isParent: true,
    parentAcademyId: null,
    current_opening_hours: null,
    formatted_address: "",
    formatted_phone_number: "",
    geometry: null,
    icon: "",
    icon_background_color: "",
    icon_mask_base_uri: "",
    international_phone_number: "",
    opening_hours: null,
    photos: [],
    place_id: "",
    plus_code: null,
    rating: 0,
    reference: "",
    reviews: [],
    types: [],
    url: "",
    user_ratings_total: 0,
    utc_offset: 0,
    vicinity: "",
    website: "",
    business_status: "OPERATIONAL",
    formatted_phone_number: "",
    international_phone_number: "",
    opening_hours: null,
    photos: [],
  });



  const inputRef = useRef(null);
  const mapRef = useRef(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [coverPic, setCoverPic] = useState(null);

  useEffect(() => {
    const fetchAcademyData = async () => {
      if (selectedCenter) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_ACADEMY_EDIT}/${selectedCenter}`, {
            headers: { 'Authorization': `Bearer ${token}` },
          });

          const academy = response.data.data.academyForm;

          setForm(prev => ({
            ...prev,
            ...academy,
            latitude: academy.latitude,
            longitude: academy.longitude,
            localityJson: academy.localityJson,
            geometry: academy.geometry,
            localityNameString: academy.localityNameString,
            addressName: academy.addressName,
            place_id: academy.place_id
          }));


          setName(academy.name);
          setEmail(academy.email);
          setAbout(academy.about);
          setMobile(
            academy.mobileNumber
              ? academy.mobileNumber.startsWith('+91')
                ? academy.mobileNumber.slice(3)
                : academy.mobileNumber
              : ''
          );
          handleInputChange('isAvailableForMachaxiTrial', academy.isAvailableForMachaxiTrial);
          handleInputChange('contactNumber', academy.contactNumber);
          setContactNumber(academy.contactNumber);
          setPassword('');
          setAddress(academy.address);
          setLocality(academy.localityNameString);
          setMaxActiveMembership(academy.maxActivePlayingMembership);
          setNotificationsEnabled(academy.isNotificationEnabled);
          setIsParentAcademy(academy.isParent);
          setFetchedAcademy(academy);
          setCoverPicUrl(academy.coverPicUrl);
          setEditMode(true);
          setValue(academy.localityNameString, false);
        } catch (error) {
        }
      }
    };
    fetchAcademyData();
  }, [selectedCenter]);

  useEffect(() => {
    if (!fetchedAcademy) return;
    if (sportOptions.length > 0 && fetchedAcademy.sportIds) {
      const selectedSports = fetchedAcademy.sportIds.map(id =>
        sportOptions.find(option => option.value === id)
      ).filter(Boolean);
      setSport(selectedSports);
    }

    if (facilityOptions.length > 0 && fetchedAcademy.facilities) {
      const facilityIds = fetchedAcademy.facilities.map(f => f.id);
      const selectedFacilities = facilityIds.map(id =>
        facilityOptions.find(option => option.value === id)
      ).filter(Boolean);
      setFacility(selectedFacilities);
    }
  }, [sportOptions, facilityOptions, fetchedAcademy]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_ACADEMY_NEW, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();

        if (data && data.success && data.data) {
          const sports = data.data.sports.map(s => ({ value: s.id, label: s.name }));
          const facilities = data.data.facilities.map(f => ({
            value: f.id,
            label: f.name
          }));

          setSportOptions(sports);
          setFacilityOptions(facilities);

          const academies = data.data.parentAcademies.map(academy => ({
            value: academy.id,
            label: academy.name
          }));
          setAcademyOptions(academies);
        }

      } catch (error) {
      }
    };

    fetchOptions();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCoverPic(file);
      setCoverPreview(URL.createObjectURL(file));

    } else {

    }
  };

  useEffect(() => {
    if (sportOptions.length > 0 && academyData?.sport?.length > 0) {
      setSport(
        academyData.sport.map(id =>
          sportOptions.find(option => option.value === id)
        ).filter(option => option)
      );
    }
    if (facilityOptions.length > 0 && academyData?.facilities?.length > 0) {
      setFacility(
        academyData.facilities.map(id =>
          facilityOptions.find(option => option.value === id)
        ).filter(option => option)
      );
    }
  }, [sportOptions, facilityOptions, academyData]);

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (!selectedCenter && !password) {
      Swal.fire({
        icon: "error",
        title: "Password Required",
        text: "Please enter a password for the Editing Academy.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (!form.latitude || !form.longitude) {
      Swal.fire({
        icon: "error",
        title: "Locality Required",
        text: "Please select a valid location from Google suggestions",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (!sport.length) {
      Swal.fire({
        icon: "error",
        title: "Missing Sport",
        text: "Please select at least one sport.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (!facility.length) {
      Swal.fire({
        icon: "error",
        title: "Missing Facility",
        text: "Please select at least one facility.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    if (!/^\d{10}$/.test(contactNumber)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Contact Number",
        text: "Please enter a valid 10-digit contact number.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    if (!locality) {
      Swal.fire({
        icon: "error",
        title: "Missing Locality",
        text: "Please enter a valid locality.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const updatedForm = {
      ...form,
      name,
      email,
      password,
      about,
      mobileNumber: mobile || null,
      address,
      sportIds: sport.map(s => s.value),
      facilityId: facility.map(f => f.value),
      maxActivePlayingMembership:
        maxActiveMembership === '' ? null : Number(maxActiveMembership),
      isNotificationEnabled: notificationsEnabled,
      isParent: isParentAcademy,
      parentAcademyId: isParentAcademy ? null : selectedParentAcademy?.value,
      contactNumber: mobile,
      localityNameString: locality,
      addressName: form.addressName ?? address,
      contactNumber,
      isAvailableForMachaxiTrial: form.isAvailableForMachaxiTrial,
      latitude: form.latitude,
      longitude: form.longitude,
      localityJson: form.localityJson,
      geometry: form.geometry,
    };

    const formData = new FormData();
    formData.append("academyForm", JSON.stringify(updatedForm));

    if (coverPic) {
      formData.append("coverPic", coverPic);
    }
    for (const pair of formData.entries()) {

    }



    try {
      const response = await axios.post(
        process.env.REACT_APP_API_ACADEMY_NEW,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Academy Updated successfully!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Error updating academy`,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleSportChange = (selectedOptions) => {
    setSport(selectedOptions);
  };

  const handleFacilityChange = (selectedOptions) => {
    setFacility(selectedOptions);
  };

  const handleInputChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/" className="breadcrumb-link">Dashboard</Link> &gt; Edit Academy Profile
      </div>
      <form onSubmit={handleSubmit} className="walkin-enquiry-form">

        <div className="floating-select-form" style={{ width: '98%' }}>
          <input
            type="text"
            name="name"
            className={`walkin-form ${name ? "has-value" : ""}`}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            required
          />
          {name && <label htmlFor="name">Name</label>}
        </div>



        <div style={{ marginBottom: '0px', color: 'black' }}>
          <label className="form-label">
            <input
              type="checkbox"
              checked={isParentAcademy}
              onChange={handleParentAcademyChange}
              className="form-checkbox"
            />
            Is Parent Academy
          </label>

          {!isParentAcademy && (
            <div className="floating-select-form" style={{ width: '98%' }}>
              <Select
                name="parentAcademy"
                options={academyOptions}
                value={selectedParentAcademy}
                onChange={setSelectedParentAcademy}
                placeholder="Select Parent Academy"
                className={`walkin-form-dropdown ${selectedParentAcademy ? 'has-value' : ''}`}
                classNamePrefix="walkin-select"
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    padding: '5px',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: 'black',
                  }),
                }}
              />
              {selectedParentAcademy && <label htmlFor="parentAcademy">Parent Academy</label>}
            </div>

          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%' }}>
          <input
            type="email"
            name="email"
            className={`walkin-form ${email ? "has-value" : ""}`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
            required
          />
          {email && <label htmlFor="email">Email</label>}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="password"
            name="password"
            className={`walkin-form ${password ? 'has-value' : ''}`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter Password"
          />
          {password && <label htmlFor="password">Password</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <textarea
            name="about"
            className={`walkin-form-comments ${about ? 'has-value' : ''}`}
            value={about}
            onChange={(e) => setAbout(e.target.value)}
            placeholder="Enter About"
            required
            style={{ height: '100px', resize: 'vertical' }}
          />
          {about && <label htmlFor="about">About</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%' }}>
          <input
            type="text"
            name="contactNumber"
            className={`walkin-form ${contactNumber ? "has-value" : ""}`}
            value={contactNumber}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
              setContactNumber(numericValue);
              handleInputChange('contactNumber', numericValue);
            }}
            placeholder="Enter Contact Number"
            inputMode="numeric"
            pattern="[0-9]*"
          />
          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            name="mobile"
            className={`walkin-form ${mobile ? 'has-value' : ''}`}
            value={mobile}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/\D/g, '');
              setMobile(numericValue.slice(0, 10));
            }}
            placeholder="Enter Mobile Number"
            inputMode="numeric"
            pattern="[0-9]*"
          />
          {mobile && <label htmlFor="mobile">Mobile Number</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            name="address"
            className={`walkin-form ${address ? 'has-value' : ''}`}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter Address"
            required
          />
          {address && <label htmlFor="address">Address</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%' }}>
          <Select
            name="sport"
            isMulti
            options={sportOptions}
            value={sport}
            onChange={handleSportChange}
            closeMenuOnSelect={false}
            className={`walkin-form-dropdown ${sport.length ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            placeholder="Select Sport"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {sport.length > 0 && <label htmlFor="sport">Sport</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%' }}>
          <Select
            name="facility"
            isMulti
            options={facilityOptions}
            value={facility}
            onChange={handleFacilityChange}
            closeMenuOnSelect={false}
            className={`walkin-form-dropdown ${facility.length ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            placeholder="Select Facility"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {facility.length > 0 && <label htmlFor="facility">Facilities</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%' }}>
          <Select
            name="locality"
            isSearchable
            options={suggestionOptions}
            value={locality ? { value: locality, label: locality } : null}
            isDisabled={!ready}
            placeholder="Search Locality"
            onInputChange={(input) => setValue(input)}
            onChange={(opt) => handleSelect(opt.value, opt.placeId)}
            noOptionsMessage={() =>
              !value
                ? "Type to search..."
                : status === "OK"
                  ? "No results found"
                  : "Loading..."
            }
            onMenuClose={clearSuggestions}
            className={`walkin-form-dropdown ${locality ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {locality && <label htmlFor="locality">Locality</label>}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="number"
            min="0"
            step="1"
            name="maxActiveMembership"
            className={`walkin-form ${maxActiveMembership !== '' ? 'has-value' : ''}`}
            value={maxActiveMembership}
            onChange={(e) => setMaxActiveMembership(e.target.value)}
            placeholder="Enter Max Active Membership"
            required
          />
          {maxActiveMembership !== '' && (
            <label htmlFor="maxActiveMembership">Max Active Playing Membership</label>
          )}
        </div>


        <fieldset className="enrollment-form-fieldset" style={{ marginTop: '0px' }}>
          <legend>Additional Options:</legend>
          <div className="form-group">
            <label className="form-label">
              <input
                type="checkbox"
                checked={notificationsEnabled}
                onChange={() => setNotificationsEnabled(!notificationsEnabled)}
                className="form-checkbox"
              />
              Enable Notifications
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              <input
                type="checkbox"
                checked={form.isAvailableForMachaxiTrial}
                onChange={(e) => handleInputChange('isAvailableForMachaxiTrial', e.target.checked)}
                className="form-checkbox"
              />
              Is available for Machaxi Trial
            </label>
          </div>
        </fieldset>

        <div className="enrollment-form-section" style={{ marginBottom: '5px' }}>
          <label className="form-label">Cover Picture:</label>
          {coverPreview ? (
            <img
              src={coverPreview}
              alt="Cover Preview"
              style={{ maxWidth: '200px', marginTop: '10px' }}
            />
          ) : (
            coverPicUrl && (
              <img
                src={coverPicUrl}
                alt="Cover"
                style={{ maxWidth: '200px', marginTop: '10px' }}
              />
            )
          )}
          <button
            className="uploadbutton"
            type='button'
            onClick={() => document.getElementById("fileInput").click()}
          >
            <span className="uploadbutton__icon">
              <svg strokeLinejoin="round" strokeLinecap="round" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" d="M0 0h24v24H0z" stroke="none"></path>
                <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"></path>
                <path d="M9 15l3 -3l3 3"></path>
                <path d="M12 12l0 9"></path>
              </svg>
            </span>
            <span className="uploadbutton__text">Upload</span>
          </button>
          <input
            id="fileInput"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden-input"
            style={{ display: "none" }}
          />

        </div>


        <div className="form-group">
          <button type="submit" className="submit-button">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default NewAcademy;